import React from 'react';
import {
    ReferenceField,
    TextField
} from 'react-admin';
import CustomTableList from './CustomTableList';

class TasteboothResultsList extends CustomTableList {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'user') {
            fieldList.push(<ReferenceField source={fieldName} reference={'wechat-users'} link="show">
                <TextField source="openid" />
            </ReferenceField>);
            return true;
        }
        return false;
    }
}

export default TasteboothResultsList;
